import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FileProgressLayouts } from '../../../../../shared/models/fileSize.model';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { Observable } from 'rxjs';
import { AllProductLine } from '../../../../../shared/enums/availableProductList.enum';

@Component({
  selector: 'app-upload-euc-form',
  standalone: false,
  templateUrl: './upload-euc-form.component.html',
  styleUrl: './upload-euc-form.component.scss',
})
export class UploadEucFormComponent implements OnInit, OnChanges {
  @Input() endUserAddress;
  @Input() soldAddress;
  @Input() isChinaOrder: boolean;
  @Input() isChina: boolean;
  @Input() isApac: boolean;
  @Input() cart$: Observable<any>;
  @Input() eucDefaultSold;

  @Output() eucFormValid: EventEmitter<any> = new EventEmitter(true);
  readonly ALLOWED_EXTENSIONS = ['jpg', 'pdf'];
  showIcon: boolean = true;
  readonly layouts = FileProgressLayouts;
  allproductline = AllProductLine;
  files = [];
  fileName: string;
  uploadParams = {
    entryNumber: 1,
    fields: 'DEFAULT',
    returnLocation: 'DEFAULT',
  };
  deleteParams = {
    returnLocation: 'DEFAULT',
  };
  deletUrl;
  uploadUrl;
  nonFilmId;
  eucUploadError: boolean = false;
  cartData: any;
  cartEndUserAddress: any;
  distinctAddress = [];
  constructor(private activeCartFacade: ActiveCartFacade) {}

  ngOnChanges(changes: SimpleChanges) {
    
   
    this.cart$.subscribe((res: any) => {
        
      if (res && res?.entries) {
        console.log(this.soldAddress);
        this.cartData = res;
        this.cartEndUserAddress = this.cartData?.entries.map(
          (e) => e.enduserAddress?.sapCustomerID
        );
        this.nonFilmId = this.endUserAddress?.sapCustomerID;
        if (this.nonFilmId && this.cartData?.cartType != 'FILM') {
          if (this.eucDefaultSold != this.nonFilmId && this.isChinaOrder) {
            this.eucFormValid.emit(false);
            this.eucUploadError = false;
          } else {
            this.eucFormValid.emit(true);
            this.eucUploadError = true;
          }
        } else {
          if (!this.cartEndUserAddress || this.cartEndUserAddress?.length == 0) {
            this.eucFormValid.emit(false);
            this.eucUploadError = false;
          } else {
            if (
              this.cartEndUserAddress?.length == 1 &&
              this.cartEndUserAddress[0] === this.eucDefaultSold ||
              this.cartData.productLine != AllProductLine.waygate ||
              !this.isChinaOrder
            ) {
              this.eucFormValid.emit(true);
              this.eucUploadError = true;
            } else if (this.cartEndUserAddress?.length > 1) {
              const distinct = new Set(this.cartEndUserAddress);
              console.log(distinct);
              if (distinct.size == 1 &&
                Array.from(distinct)[0] != undefined &&
                Array.from(distinct)[0] === this.eucDefaultSold
              ) {
                this.eucFormValid.emit(true);
                this.eucUploadError = true;
              } else {
                this.eucFormValid.emit(false);
                this.eucUploadError = false;
              }
            }
          }
        }
      }
    });
  
}

  ngOnInit(): void {
    this.getCartId();
    if (this.isOrderForChina) {
    } else {
      this.eucFormValid.emit(true);
      this.eucUploadError = true;
    }
  }

  getCartId() {
    this.activeCartFacade.getActiveCartId().subscribe((cartId) => {
      if (cartId) {
        this.uploadUrl =
          'users/current/dscheckout/' + cartId + '/true/uploadOrderAttachment';
        this.deletUrl =
          'users/current/dscheckout/' + cartId + '/true/removeOrderAttach';
      }
    });
  }

  selectedFiles(event) {
    this.files = event;
    this.eucFormValid.emit(true);
    this.eucUploadError = true;
  }

  deletedFiles(event) {
    if (this.files.indexOf(event) > -1) {
      this.files.splice(this.files.indexOf(event), 1);
    }
    this.eucFormValid.emit(false);
    this.eucUploadError = false;
  }

  get isOrderForChina(): boolean {
    return this.isChinaOrder;
  }
}
